import { m as map, p as of } from './Option-87dfe66c.js';
import { p as pipe } from './ReadonlyNonEmptyArray-3599e877.js';
import { u as unfoldTree, f as fromTraversable, P as Prism, a as fold, t as tree } from './index-907c0cc3.js';
import { generateId } from './converters/generateRandomId.js';
import './ReadonlyRecord-da7aaead.js';
import './string-04247af1.js';
import 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getModifier = (nodesAccessor, nodesSetter) => (root) => {
  class TraversalModifier {
    constructor(tree2, traversal) {
      this.tree = tree2;
      this.traversal = traversal;
    }
    filter(predicate) {
      return new TraversalModifier(
        this.tree,
        this.traversal.composePrism(Prism.fromPredicate(predicate))
      );
    }
    set(setter) {
      return pipe(
        this.traversal.asFold().getAll(this.tree),
        map((node) => node._modId),
        foldTree(this.tree, setter)
      );
    }
  }
  const modifyById = (idsToSet, setter) => (modTreeNode) => {
    const _a = modTreeNode, { _modId } = _a, rest = __objRest(_a, ["_modId"]);
    const node = rest;
    return idsToSet.includes(_modId) ? setter(node) : node;
  };
  const mergeWith = (prefix) => (suffix) => [...prefix, ...suffix];
  const toArray = (node) => Array.isArray(node) ? node : of(node);
  const foldTree = (tree2, setter) => (idsToSet) => fold((root2, forest) => __spreadValues(__spreadValues({}, root2), nodesSetter(
    forest.reduce(
      (modifiedForest, node) => pipe(node, modifyById(idsToSet, setter), toArray, mergeWith(modifiedForest)),
      []
    )
  )))(tree2);
  const tree$1 = unfoldTree(root, (node) => [
    __spreadProps(__spreadValues({}, node), { _modId: generateId() }),
    nodesAccessor(node)
  ]);
  return new TraversalModifier(tree$1, fromTraversable(tree)());
};

export { getModifier };
//# sourceMappingURL=modifier-infra.js.map
